import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';
import { CancelAutomaticPaymentsFlowService } from '../shared/cancel-automatic-payments-flow.service';
import { SessionService } from '../../../../../../shared/session/session.service';

@Injectable()
export class CancelAutomaticPaymentsConfirmationGuard implements CanActivate {
    constructor(
        private cancelAutomaticPaymentsFlowService: CancelAutomaticPaymentsFlowService,
        private router: Router,
        private session: SessionService
    ) { }

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.cancelAutomaticPaymentsFlowService.flowInPlay || this.router.parseUrl(environment.ISB.ENDPOINTS.RELATIVE.paymentPreferences({
            accountNumber: this.session.billingAccountNumber,
            sessionId: this.session.a2aSessionId
        }));
    }
}
